import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {FormService} from '../../services/form.service';
import {GridApi} from 'ag-grid-community';
import {Dienst, ShipmentInfo} from '../../models';

@Component({
  selector: 'lib-ds-sendungskorrektur',
  templateUrl: './ds-sendungskorrektur.component.html',
  styleUrls: ['./ds-sendungskorrektur.component.css']
})
export class DsSendungskorrekturComponent implements OnInit {

  public gridApi: GridApi;
  public modalRef: BsModalRef;
  public dienste: Dienst;
  public singleShipmentInformation: ShipmentInfo;

  @Input() shipmentInfos: ShipmentInfo[];
  @Input() allowedDienste: Dienst;

  @Output() sendCorrectedValues = new EventEmitter<any>();

  constructor(private modalService: BsModalService, private formService: FormService) {
    this.formService.submittedForm.subscribe((form) => {
      this.sendCorrectedValues.emit(form);
    });
  }

  ngOnInit(): void {
  }

  openModal(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
    this.shipmentInfos.forEach((shipment: ShipmentInfo) => {
      this.singleShipmentInformation = shipment;
    });
    this.dienste = this.allowedDienste;
  }

  closeModal(event: any) {
    this.modalRef.hide();
  }

}
